// extracted by mini-css-extract-plugin
export default {"container":"AssetInput-module__container--jc4uJ"};